import { forwardRef, useRef, type ImgHTMLAttributes } from 'react';
import type { TypeImageDetailed } from 'types/autogen/contentful';
import { createSrcSet } from './shared/helpers';
import { default as GenericImage } from 'components/generic/Image';
import styled from 'styled-components';

const StyledGenericImage = styled(GenericImage)`
    max-width: 100%;
    height: auto;
    width: auto;
`;

type ImageProps = (TypeImageDetailed | undefined) & ImgHTMLAttributes<HTMLImageElement>;

const Image = forwardRef<HTMLImageElement, ImageProps>((props, ref) => {
    const { fields, metadata, sys, ...restProps } = props;
    const { image, altText, localizedImage } = fields;
    const imageAsset = localizedImage || image;

    if (!imageAsset) return null;

    const { fields: assetFields } = imageAsset;

    if (!assetFields?.file) return;
    const { file } = assetFields;

    const {
        details: { image: imageFile },
        url
    } = file;

    return (
        <StyledGenericImage
            ref={ref}
            src={url}
            alt={altText || ''}
            srcSet={createSrcSet(file)}
            width={imageFile?.width}
            height={imageFile?.height}
            {...restProps}
        />
    );
});

export default Image;
